<template>
  <div>
    <template v-if="!['thailandpostmart'].includes(selectedBot.type)">
      <a href="https://blog.zwiz.ai/วิธีการลงสินค้าผ่านไฟล/" target="blank">
        <em style="font-size: 16px; color: #ff706b" class="fas fa-question-circle" />
      </a>

      <v-btn
        color="primary"
        :disabled="delayImport"
        :loading="loading"
        outline
        @click="onClickUploadButton"
      >
        <em class="fas fa-file-import" />
        &nbsp;
        {{ $t('import') }}
      </v-btn>
      <input
        type="file"
        class="form-control-file pt-2"
        name="csvUpload"
        :id="'csvUpload'"
        data-vv-as="File"
        v-validate="'mimes:text/xlsx'"
        accept=".xlsx"
        @input="onFileChange($event)"
        style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
      />
    </template>
  </div>
</template>

<script>
import api from '@/api'
import powerbuyShopServicesApi from '@/api/powerbuy-shop-services'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'

export default {
  data() {
    return {
      delayImport: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    onClickUploadButton() {
      document.getElementById('csvUpload').click()
    },
    onFileChange(event) {
      let vm = this
      vm.loading = true
      let files = event.target.files || event.dataTransfer.files
      var myFile = files[0]
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array' })

        /* DO SOMETHING WITH workbook HERE */
        var result = []
        for (var sheet in workbook.Sheets) {
          result.push(vm.trimObj(XLSX.utils.sheet_to_json(workbook.Sheets[sheet])))
        }
        if (vm.selectedBot.theme == 'scgdistribution') {
          vm.uploadExcelScgdistribution(result)
        } else if (vm.$store.state.iccpage.includes(vm.selectedBot.pageid)) {
          vm.uploadExcelICC(result)
        } else if (['powerbuy'].includes(vm.selectedBot.theme)) {
          vm.uploadPowerbuyProducts(result)
        } else {
          vm.uploadExcel(result)
        }
      }
      reader.readAsArrayBuffer(myFile)
    },
    trimObj(obj) {
      var vm = this
      if (!Array.isArray(obj) && typeof obj != 'object') return obj
      return Object.keys(obj).reduce(
        function (acc, key) {
          acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : vm.trimObj(obj[key])
          return acc
        },
        Array.isArray(obj) ? [] : {}
      )
    },
    uploadExcelScgdistribution(file) {
      var vm = this
      // var productlength = 0
      // file[1].map((el) => {
      //   var op1 = el.Option1Detail ? el.Option1Detail.split(',').length : 0
      //   var op2 = el.Option2Detail ? el.Option2Detail.split(',').length : 0
      //   if (op2) {
      //     productlength += op1 * op2
      //   } else productlength += op1
      // })
      if ((file[2] && file.length == 3) || true) {
        api.scgdistributionimportproducts(
          {
            products: file,
            pageid: this.selectedBot.pageid,
            isCentral: [
              ...this.$store.state.centralPage,
              '104716585038207',
              '362065616073'
            ].includes(this.selectedBot.pageid)
          },
          (err, response) => {
            this.loading = false

            if (response.responsecode == 200) {
              vm.$swal
                .fire({
                  type: 'success',
                  text: 'นำเข้าสินค้าสำเร็จ'
                })
                .then((result) => {
                  window.location.reload()
                })
            } else {
              this.$swal.fire({
                text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
              })
            }
          }
        )
      } else {
        this.$swal.fire({
          text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
        })
        this.loading = false
      }
    },
    uploadExcel(file) {
      var vm = this
      if (file[2] && file.length == 3) {
        api.postuploadproducts(
          {
            products: file,
            pageid: this.selectedBot.pageid,
            isCentral: [
              ...this.$store.state.centralPage,
              '104716585038207',
              '362065616073'
            ].includes(this.selectedBot.pageid)
          },
          (err, response) => {
            this.loading = false
            if (response.responsecode == 200) {
              vm.$swal
                .fire({
                  type: 'success',
                  text: 'นำเข้าสินค้าสำเร็จ'
                })
                .then((result) => {
                  window.location.reload()
                })
            } else {
              this.$swal.fire({
                text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
              })
            }
          }
        )
      } else {
        this.$swal.fire({
          text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
        })
        this.loading = false
      }
    },
    uploadExcelICC(file) {
      var vm = this
      if (file[2] && file.length == 3) {
        api.importproductkeyword(
          {
            products: file,
            pageid: this.selectedBot.pageid
          },
          (err, response) => {
            this.loading = false
            if (response && response.responsecode == 200) {
              vm.$swal
                .fire({
                  type: 'success',
                  text: 'นำเข้าสินค้าสำเร็จ'
                })
                .then((result) => {
                  window.location.reload()
                })
            } else {
              this.$swal.fire({
                text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
              })
            }
          }
        )
      } else {
        this.$swal.fire({
          text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
        })
        this.loading = false
      }
    },
    async uploadPowerbuyProducts(file) {
      const vm = this
      try {
        let data = {
          pageId: vm.selectedBot.pageid,
          file: file[0]
        }

        vm.$store.dispatch('loading')
        const response = await powerbuyShopServicesApi.importStock({ data })
        vm.$store.dispatch('loading')
        this.loading = false

        if (response && response.status === 200) {
          vm.$swal
            .fire({
              type: 'success',
              text: 'นำเข้าสินค้าสำเร็จ'
            })
            .then((result) => {
              if (result.value) {
                vm.$emit('success')
              }
            })
        } else {
          vm.$swal.fire({
            text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
          })
        }
      } catch (error) {
        this.loading = false
        vm.$store.dispatch('loading')
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ImportShop.vue